// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const securityPrivacySections: PaneSection[] = [
  {
    section: 'overview',
    title: 'Security and privacy',
    body: 'This is where you control what other people on Ping can see about you. Turn each of the settings below on or off to fit how you like to chat.',
  },
  {
    section: 'read-receipts',
    title: 'Send read receipts',
    body: 'When this is on, people can see when you have read their messages. Turn it off and you can read quietly without letting anyone know.',
  },
  {
    section: 'typing',
    title: 'Show typing indicators',
    body: 'When this is on, people see the little three dots while you are writing a reply. Turn it off to keep your typing to yourself.',
  },
  {
    section: 'last-seen',
    title: 'Last seen',
    body: 'This lets you choose who can see when you were last online. It is coming soon, so keep an eye out for it.',
  },
];
